/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

module.exports = {

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.DYNAMIC_BODY
     * @type {number}
     * @since 3.0.0
     */
    DYNAMIC_BODY: 0,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.STATIC_BODY
     * @type {number}
     * @since 3.0.0
     */
    STATIC_BODY: 1,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.GROUP
     * @type {number}
     * @since 3.0.0
     */
    GROUP: 2,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.TILEMAPLAYER
     * @type {number}
     * @since 3.0.0
     */
    TILEMAPLAYER: 3,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.FACING_NONE
     * @type {number}
     * @since 3.0.0
     */
    FACING_NONE: 10,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.FACING_UP
     * @type {number}
     * @since 3.0.0
     */
    FACING_UP: 11,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.FACING_DOWN
     * @type {number}
     * @since 3.0.0
     */
    FACING_DOWN: 12,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.FACING_LEFT
     * @type {number}
     * @since 3.0.0
     */
    FACING_LEFT: 13,

    /**
     * [description]
     * 
     * @name Phaser.Physics.Arcade.FACING_RIGHT
     * @type {number}
     * @since 3.0.0
     */
    FACING_RIGHT: 14

};



//////////////////
// WEBPACK FOOTER
// ./physics/arcade/const.js
// module id = 68
// module chunks = 0